import styled from 'styled-components';
import { colors } from '../../stylesheets';

const HR = styled.hr`
  border-color: ${(props) =>
    props.type ? colors[props.type] : colors.lighterGray};
  border-style: ${(props) => props.borderStyle || 'solid'};
  margin-top: 0;
`;

export { HR };
